import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const AdminList = () => {
  const [admins, setAdmins] = useState([]);
  const [error, setError] = useState("");

  const token = JSON.parse(localStorage.getItem("user"))?.token;

  useEffect(() => {
    if (!token) {
      setError("Token not found. Please log in again.");
      return;
    }

    axios
  .get(`${API_BASE}/api/admin/profile/admins`, {
    headers: { Authorization: `Bearer ${token}` },
  })

      .then((res) => setAdmins(res.data))
      .catch((err) => {
        setError("Failed to load admins.");
        console.error(err);
      });
  }, [token]);

  return (
    <div className="bg-white p-4 rounded shadow mt-6">
      <h3 className="text-xl font-semibold mb-2">All Admins</h3>
      {error && <p className="text-red-500">{error}</p>}
      <ul className="space-y-1">
        {admins.map((admin) => (
          <li key={admin._id}>
            <strong>{admin.name || admin.username}</strong> – {admin.email} ({admin.role})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminList;
